import { LogicService } from '../../../core/canvas-logic/base/logic-service';
import { CommonEditLogic } from './common-edit-logic';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { InterfaceFactoryOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import { ShapeEditLogic } from './shape-edit-logic';
import { PictureEditLogic } from './picture-edit-logic';
import { ConnectorEditLogic } from './connector-edit-logic';
import { TableEditLogic } from './table-edit-logic';
import { GroupEditLogic } from './group-edit-logic';
import { ComponentFactory } from '../../../core/canvas-render/elements/component-factory';
import { ChartEditLogic } from '@src/slide/content-viewer/service/canvas-renderer/entry/pc-edit/logic/chart-edit-logic';
import { SmartArtEditLogic } from './smart-art-edit-logic';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IConnectorModel } from '@src/slide/domain/ui-model/element-modeles/Interface/connector-model.interface';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import { ISmartArtModel } from '@src/slide/domain/ui-model/element-modeles/Interface/smart-art-model.interface';
import { ILogic } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-logic/base/logic.interface';
import {
    IBaseComponent,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/base-component/base-component.interface';
import {
    ComponentTypes,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/base-component/component-types';
import {
    PlaceHolderLogic,
} from '@src/slide/content-viewer/service/canvas-renderer/entry/base/logic/component-logic/place-holder-logic';
import { TableCellWrapperLogic } from '@src/slide/content-viewer/service/canvas-renderer/entry/base/logic/component-logic/table-cell-wrapper-logic';
import { PlaceHolderIconLogic } from '@src/slide/content-viewer/service/canvas-renderer/entry/base/logic/component-logic/place-holder-icon-logic';
import { TextEditorLogic } from '@src/slide/content-viewer/service/canvas-renderer/entry/base/logic/component-logic/text-editor-logic';

export class PcEditLogicService extends LogicService {
    declare public logicMap: Map<string, CommonEditLogic>;

    public createLogic(factoryOptions: InterfaceFactoryOptions, component: ComponentFactory): CommonEditLogic | null {
        const { model } = factoryOptions;
        switch (model.type) {
            case UIModelType.SHAPE:
                return new ShapeEditLogic(factoryOptions as InterfaceFactoryOptions<IShapeModel>, component);
            case UIModelType.IMAGE:
                return new PictureEditLogic(factoryOptions as InterfaceFactoryOptions<IPictureModel>, component);
            case UIModelType.CONNECTOR:
                return new ConnectorEditLogic(factoryOptions as InterfaceFactoryOptions<IConnectorModel>, component);
            case UIModelType.TABLE:
                return new TableEditLogic(factoryOptions as InterfaceFactoryOptions<ITableModel>, component);
            case UIModelType.GROUP:
                return new GroupEditLogic(factoryOptions as InterfaceFactoryOptions<IGroupModel>, component);
            case UIModelType.CHART:
                return new ChartEditLogic(factoryOptions as InterfaceFactoryOptions<IChartModel>, component);
            case UIModelType.SMART_ART:
                return new SmartArtEditLogic(factoryOptions as InterfaceFactoryOptions<ISmartArtModel>, component);
            default:
                return null;
        }
    }

    public getLogic(factoryOptions: InterfaceFactoryOptions): CommonEditLogic | undefined {
        return this.logicMap.get(factoryOptions.model.key);
    }

    public removeLogic(factoryOptions: InterfaceFactoryOptions): void {
        const logic = this.getLogic(factoryOptions);
        logic?.reactionDisposers.forEach(disposer => disposer());
        /* picture + shape */
        // @ts-ignore
        logic?.dragListener?.();
        // @ts-ignore
        logic?.selectedListener?.();
        // @ts-ignore
        logic?.videoPosterListener?.();
        // @ts-ignore
        logic?.iframePosterListener?.();
        /* picture + shape */
        logic?.flagEventsInstance?.cancelAllEvents?.();

        super.removeLogic(factoryOptions);
    }

    public createComponentLogic(factoryOptions: InterfaceFactoryOptions, component: IBaseComponent): ILogic | null {
        const componentType = component.getComponentType();
        switch (componentType) {
            case ComponentTypes.PLACEHOLDER:
                return new PlaceHolderLogic(factoryOptions as InterfaceFactoryOptions<IShapeModel>, component);
            case ComponentTypes.TABLECELL:
                return new TableCellWrapperLogic(factoryOptions as InterfaceFactoryOptions<ITableModel>, component);
            case ComponentTypes.PLACEHOLDERICON:
                return new PlaceHolderIconLogic(factoryOptions as InterfaceFactoryOptions<ITableModel>, component);
            case ComponentTypes.TEXTEDITOR:
                return new TextEditorLogic(factoryOptions, component);
        }
        return null;
    }
}
